import React, { Component, PropTypes } from 'react'
import './App.css';
import Overlay from './Overlay';
import Grid from './Grid';

const propTypes = {};

const defaultProps = {};

class Map extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  componentDidMount(){
    this.setState(() => {
      return { map: this.props.map };
    });    
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState(() => {
      return { map: nextProps.map };
    });
  }

  render() {
   
    return (
      <div>
        <div id="map">
        <Overlay changeMetric={ this.props.changeMetric.bind(this) } metric={ this.props.metric } />
        </div>
        
        <Grid mapboxgl={this.state.mapboxgl} loading={this.props.loading} map={this.state.map} zoom={this.props.zoom} readings={this.props.readings} metric={this.props.metric} />
      </div>
    );
  }
}

Map.propTypes = propTypes;

Map.defaultProps = defaultProps;

export default Map;



// WEBPACK FOOTER //
// ./src/Map.js